import React from 'react';
import axios from 'axios';
import { API, Badge, TextField, errText, fmt, formValues, propName, timeLabel, todayPT, useHeaders, usePortal, useSubmit } from '../clientportal/kit';

export const OUTCOMES = [['unable_to_access', 'Unable to Access'], ['partially_completed', 'Partially Completed'], ['unsafe_to_proceed', 'Unsafe to Proceed']];
export const jobDay = (j) => fmt(j.start_time, { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/(\d+)\/(\d+)\/(\d+)/, '$3-$1-$2');
export const jobStatus = (j) => (j.visit_outcome?.label ? j.visit_outcome.label
  : ['Completed', 'Service Finished'].includes(j.status) ? 'Completed' : j.status === 'In Progress' ? 'In progress' : j.status === 'Canceled' ? 'Canceled' : 'Assigned');
export const isFuture = (j) => jobDay(j) > todayPT();
export const clientFirst = (j) => (j.client_name || '').split(' ')[0] || 'Client';
export const duration = (j) => { const m = Math.round((new Date(j.end_time) - new Date(j.start_time)) / 60000); return m >= 120 ? `${+(m / 60).toFixed(1)} hours planned` : m === 60 ? '1 hour planned' : `${m} minutes planned`; };

export const JobCard = ({ j, onOpen }) => (
  <article className="visit" data-testid={`guru-job-${j.id}`}>
    <div className="visit-date"><small>{fmt(j.start_time, { weekday: 'short' })}</small>{fmt(j.start_time, { day: '2-digit' })}</div>
    <div><h2>{propName(j.address)}</h2><p>{j.service?.name || 'Clean'} · {timeLabel(j.start_time)} PT</p><p>{clientFirst(j)} · {duration(j)}</p></div>
    <div className="visit-actions"><Badge>{jobStatus(j)}</Badge><button className="text-button" onClick={onOpen} data-testid={`guru-job-open-${j.id}`}>Open job ↗</button></div>
  </article>
);

// Requests to the office: issues, supplies, time corrections, availability — all land in Needs Review
export const OfficeRequestForm = ({ kind, title, appointmentId, extra, children, submitLabel = 'Send to the team', onDone, note }) => {
  const headers = useHeaders();
  const { toast, closeDrawer } = usePortal();
  const [busy, run] = useSubmit();
  const submit = (e) => {
    e.preventDefault();
    const f = formValues(e);
    run(async (rid) => {
      try {
        const x = extra ? extra(f) : {};
        await axios.post(`${API}/api/review-items`, { kind, title: x.title || title, details: x.details ?? f.note, appointment_id: x.appointment_id || appointmentId || null,
          requested_date: x.requested_date || null, client_request_id: rid }, { headers });
        toast('Sent. The office will review it and reply here.'); closeDrawer(); onDone?.();
      } catch (err) { toast(errText(err)); }
    });
  };
  return (
    <form onSubmit={submit} data-testid={`guru-form-${kind}`}>
      {children}
      <TextField label="Details for your team" name="note" required minLength={3} maxLength={2000} />
      <div className="notice">{note || 'Your report goes to the office review queue with its delivery status shown under your requests.'}</div>
      <button className="primary" type="submit" disabled={busy} data-testid={`guru-form-submit-${kind}`}>{busy ? 'Sending…' : submitLabel}</button>
    </form>
  );
};
